export default __webpack_public_path__ + "static/media/Logo-2.3f227664.png";